<template>
  <v-container v-if="loading" fluid fill-height>
    <v-layout align-center justify-center fill-height>
      <v-progress-circular indeterminate></v-progress-circular>
    </v-layout>
  </v-container>
  <v-container v-else fluid grid-list-md fill-height>
    <v-layout row wrap justify-space-between>
      <v-flex class="pa-3" xs12 sm12 md6 lg6 v-for="(gw, id) in gateways" :key="gw.id" d-flex>
        <v-card height="400">
          <ip-way-s3-image :url="gw.imageUrl" aspect-ratio="2.75">
            <v-layout row class="pa-2">
              <v-tooltip right>
                <template v-slot:activator="{ on }">
                  <v-icon
                    v-on="on"
                    color="white"
                    class="ma-2"
                    large
                  >{{gw.state.connected ? 'cloud_queue' : 'cloud_off'}}</v-icon>
                </template>
                <span>{{$t(gw.state.connected ? 'tooltip-cloud-online' : 'tooltip-cloud-offline')}}</span>
              </v-tooltip>
              <v-spacer />
              <v-tooltip left>
                <template v-slot:activator="{ on }">
                  <v-btn
                    v-on="on"
                    color="transparent"
                    fab
                    @click="toggleNotification(gw)"
                    class="ma-2"
                    :loading="gw.doNotDisturb == undefined"
                  >
                    <v-icon
                      :color="gw.doNotDisturb ? 'red' : 'white'"
                      large
                    >{{gw.doNotDisturb ? 'far fa-bell-slash' : 'far fa-bell'}}</v-icon>
                  </v-btn>
                </template>
                <span>{{$t(gw.doNotDisturb ? 'tooltip-donotodisturb-disabled-message' : 'tooltip-donotodisturb-enabled-message')}}</span>
              </v-tooltip>
            </v-layout>
          </ip-way-s3-image>

          <v-card-title primary-title>
            <div>
              <h3 class="headline mb-0">{{gw.title}}</h3>
              <div>S/N: {{ gw.gw }}</div>
            </div>
          </v-card-title>

          <v-card-text></v-card-text>
          <v-spacer></v-spacer>
          <v-card-actions>
            <ip-way-photo-picker @preview="updatePreview(gw.flat, $event)" :flat="gw.flat"></ip-way-photo-picker>
            <gateway-edit :gateway="gw"></gateway-edit>
            <gateway-delete :gateway="gw"></gateway-delete>
            <!--<gateway-edit-features :flat="gw"></gateway-edit-features>-->
            <v-spacer />
            <v-btn flat color="orange" :to="'/gw/'+id">
              {{$t('function-button-preview')}}
              <v-icon right dark>remove_red_eye</v-icon>
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import GatewayNew from './GatewayNew.vue';
import GatewayEdit from './GatewayEdit.vue';
import GatewayDelete from './GatewayDelete.vue';
import GatewayEditFeatures from './GatewayEditFeatures.vue';
import IpWayS3Image from './storage/IpWayS3Image.vue';
import IpWayPhotoPicker from './storage/IpWayPhotoPicker.vue';
import IpWayPhotoPickerOld from './storage/IpWayPhotoPickerOld.vue';
import Storage from '@aws-amplify/storage';
import EventBus from '../events/EventBus';
import { mapState } from 'vuex';
export default {
  name: 'GatewayList',
  components: {
    GatewayNew,
    GatewayEdit,
    GatewayDelete,
    GatewayEditFeatures,
    IpWayS3Image,
    IpWayPhotoPicker,
    IpWayPhotoPickerOld
  },
  mounted() {
    this.$store.dispatch('flats/fetch');
    EventBus.$on('fileUpload', img => {
      console.warn('You need to reload the image');
      window.location.reload();
    });
  },
  data: () => {
    return {
      saving: 0
    };
  },
  methods: {
    updatePreview(flat, image) {
      this.gateways.forEach(gateway => {
        if (gateway.flat == flat)
          gateway.imageUrl = image;
      });
    },
    toggleNotification(gw) {
      console.log('Going to toggle preferences');
      let old_value = gw.doNotDisturb;
      let value = !old_value;
      gw.doNotDisturb = undefined;
      this.$store
        .dispatch('flats/put', {
          flat: gw.flat,
          doNotDisturb: value
        })
        .then(() => {
          gw.doNotDisturb = value;
        })
        .catch(e => {
          gw.doNotDisturb = old_value;
          //segnalare l'errore
          console.log(e.response);
        });

      //this.$store.dispatch('flats/fetch');
    }
  },
  computed: {
    ...mapState('flats', ['loading', 'gateways'])
  }
};
</script>

<style>
</style>
